import { useEffect, useState } from "react";

/**
 * Wall-clock time that re-renders on an interval, so anything showing a live
 * clock does not drift once the page has been left open.
 */
export function useNow(intervalMs = 60_000) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);

    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
